<template>
    <div>
        <v-tabs
            v-model="activeSubTab"
            class="integration-filters-subtabs"
            background-color="white"
            color="dark"
            slider-color="dark"
            show-arrows="mobile"
        >
            <v-tab>API Filter</v-tab>
            <v-tab>Data Filter</v-tab>

            <v-tab-item>
                <integrations-filter
                    :integrationFilters="integrationFilters"
                    :is_disabled="is_disabled"
                />
            </v-tab-item>

            <v-tab-item>
                <integration-data-filters
                    :integrationId="resolvedIntegrationId"
                    :is_disabled="is_disabled"
                />
            </v-tab-item>
        </v-tabs>
    </div>
</template>

<script>
import IntegrationDataFilters from './IntegrationDataFilters.vue'
import IntegrationsFilter from './IntegrationsFilter.vue'

export default {
    components: {
        IntegrationDataFilters,
        IntegrationsFilter,
    },

    props: {
        // Some parents pass integration as `{}` initially (truthy) before async fetch completes.
        // We keep this optional and fall back to the route param.
        integrationId: { type: [Number, String], default: null },
        integrationFilters: { type: Array, default: () => [] },
        is_disabled: { type: Boolean, default: false },
    },

    computed: {
        resolvedIntegrationId() {
            return this.integrationId || this.$route.params.id
        },
    },

    data() {
        return {
            activeSubTab: 0,
        }
    },
}
</script>

<style scoped>
.integration-filters-subtabs {
    /* Match Live Rate Settings style */
    background: #fff;
}

/* Vuetify 2: style the tab labels */
.integration-filters-subtabs ::v-deep .v-tab {
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: rgba(0, 0, 0, 0.5);
    min-height: 40px;
    padding-top: 6px;
    padding-bottom: 6px;
}

.integration-filters-subtabs ::v-deep .v-tab--active {
    color: rgba(0, 0, 0, 0.87);
}

/* OVERRIDES: prevent global `.v-tabs.fusedship-tab` (pill tabs) from affecting this nested tab bar */
.integration-filters-subtabs ::v-deep .v-tab {
    background-color: transparent !important;
    border: none !important;
}

.integration-filters-subtabs ::v-deep .v-tab--active {
    background-color: transparent !important;
    border: none !important;
}

/* parent `.fusedship-tab` hides the slider; re-enable it for this sub-tab bar */
.integration-filters-subtabs ::v-deep .v-tabs-slider-wrapper {
    opacity: 1 !important;
}

/* parent `.fusedship-tab` adds a bottom line via a pseudo-element; disable it here */
.integration-filters-subtabs ::v-deep .v-slide-group__wrapper:after {
    content: none !important;
    display: none !important;
    border-bottom: none !important;
}

</style>
